import React, {Component} from "react";
import {Form, Input , Radio,Row,Col,Modal} from 'antd';
import NHFetch from "../../../utils/NHFetch";
import Viewer from 'react-viewer';

const FormItem = Form.Item;

const baseUrlPath = "/swbl/lstd"; //基础路径

/**
 * 绿色通道查看表单
 * @author admin
 * @date 2018-03-16 11:28:34
 * Version: 1.0
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fj:[],
            hjsqdxList:[],
            hjsqdxmc:"",//缓交申请对象名称
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'],   //可以导入的图片格式
            previewVisible: false,
        }
    }
    componentWillMount(){
        //根据lstdid 获取办理原因
        let initFormData = this.props.initFormData;
        this.loadLstdHjsqdx();
        NHFetch(`/swbl/lstd/${initFormData.PKID}/getFjList`,"get").then(res=>{
            if(res){
                this.setState({fj:res.data});
            }
        })

    }

    // 获取缓交对象数据
    loadLstdHjsqdx=()=>{
        const {initFormData } = this.props;
        let X_HJSQDXLXDM = [];
        let hjsqdxmc = '';
        NHFetch('front/zhxg-unauth/yxwz/proData/selectDataList','get','sign=dmk_YXXT_LSTD_HJSQDXLX').then(res=>{
            if(res){
                if(res.data){
                    let hjsqdxList = res.data;
                    if(initFormData.X_HJSQDXLX){
                        X_HJSQDXLXDM = initFormData.X_HJSQDXLX.split(',');
                        hjsqdxList.map((item,index)=>{
                            X_HJSQDXLXDM.map(elem=>{
                                if(elem == item.VALUE){
                                    if(index == 0){
                                        hjsqdxmc += item.LABEL;
                                    }else{
                                        hjsqdxmc += ',' + item.LABEL;
                                    }
                                }
                            })
                        })
                    }
                    this.setState({
                        hjsqdxList:res.data,
                        hjsqdxmc:hjsqdxmc
                    })
                }
            }
        });
    }

     //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常
     setJudge = (name, map) => {
        let flag = false;
        map.map(item => {
            if (name.indexOf(item) !== -1) {
                flag = true;
            }
        })
        return flag;
    }
    // (这个地方包含处理审核和新增的图片预览逻辑。)点击文件链接或预览图标时的回调
    handlePreview = (fj, fjid) => {
        let isImage = true;
        const name = fj.name || fj.fjmc;
        fjid = fjid || fj.response.data.ssbh
        if (
            !this.setJudge(name, this.state.judgeImgList)
        ) {
            isImage = false;
        }

        if (isImage) {
            this.showPreview(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        } else {
            window.open(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        }
    };
    showPreview = (url) => {
        this.setState({
            previewImage: url,
            previewVisible: true
        });
    }
    // 关闭图片弹窗
    handleCancel = () => this.setState({ previewVisible: false });



    render() {
        const initFormData = this.props.initFormData;

        return (
            <div>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}> 姓名(学号)：</Col>
                    <Col span={8}>{initFormData.XM?initFormData.XM:''}{initFormData.XH?initFormData.XH:""}</Col>
                    <Col span={4} style={{textAlign:'right'}}>性别：</Col>
                    <Col span={8}>{initFormData.XB}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>学院：</Col>
                    <Col span={8}>{initFormData.BMMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>专业：</Col>
                    <Col span={8}>{initFormData.ZYMC}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>班级：</Col>
                    <Col span={8}>{initFormData.BJMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>年度：</Col>
                    <Col span={8}>{initFormData.ND}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>绿色通道申请:</Col>
                    <Col span={20}>{initFormData.SFBLLSTDMC}</Col>
                </Row>
                {initFormData && initFormData.SFBLLSTD=='1' && <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>申请类型：</Col>
                    <Col span={20}>{initFormData.DKLXMC}</Col>
                </Row>}
                {initFormData && initFormData.SFBLLSTD=='1' && initFormData.DKLX=='whrj_1' && <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>办理原因：</Col>
                    <Col span={20}>{initFormData.BLYY}</Col>
                </Row>}
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    {initFormData.SFBLLSTD=='1' && <Col span={4} style={{textAlign:'right'}}>{initFormData  && initFormData.SFBLLSTD=='1'&& (initFormData.DKLX=='whrj_1'||initFormData.DKLX=='whrj_4')?'缓交金额：':'贷款金额：'}</Col>}
                    {initFormData.SFBLLSTD=='1' && <Col span={8}>{initFormData.BLJE}元</Col>}
                    <Col span={4} style={{textAlign:'right'}}>办理时间：</Col>
                    <Col span={8}>{initFormData.BLSJ}</Col>
                </Row>
                {initFormData && initFormData.SFBLLSTD=='1' && initFormData.DKLX=='whrj_1' && <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>贷款银行：</Col>
                    <Col span={8}>{initFormData.DKYHMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>6位数回执校验码：</Col>
                    <Col span={8}>{initFormData.HZJYM}</Col>
                </Row>}
                {initFormData && initFormData.SFBLLSTD=='1' && initFormData.DKLX=='whrj_4' && <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>缓交截止时间：</Col>
                    <Col span={8}>{initFormData.X_HJJZRQ}</Col>
                </Row>}
                {initFormData && initFormData.SFBLLSTD=='1' && initFormData.DKLX=='whrj_4' && <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                     <Col span={4} style={{textAlign:'right'}}>缓交申请对象类型：</Col>
                    <Col span={20}>{this.state.hjsqdxmc}</Col>
                </Row>}
                {initFormData && initFormData.SFBLLSTD=='1' && initFormData.DKLX=='whrj_1' && <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>申请理由：</Col>
                    <Col span={8}>{initFormData.SQSM}</Col>
                </Row>}
                <Row gutter={24}>
                    <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                        style={{color: 'rgba(0, 0, 0, 0.85)'}}>材料证明&nbsp;: </span></Col>
                    <Col span={20}>
                        {this.state.fj.map((elem, index) => {
                            return (
                                <div style={{marginBottom: '20px'}}>
                                    <a onClick={() => {
                                        this.handlePreview(elem, elem['fjid']);
                                    }}>{elem['fjmc']}</a>
                                </div>
                            )
                        })
                        }
                    </Col>
                </Row>
                {initFormData.SJLY=='2' && <div>
                    <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                        <Col span={4} style={{textAlign:'right'}}>审核状态：</Col>
                        <Col span={8}>{initFormData.SHZTMC}</Col>
                        <Col span={4} style={{textAlign:'right'}}>审核时间：</Col>
                        <Col span={8}>{initFormData.SHSJ}</Col>
                    </Row>
                    <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                        <Col span={4} style={{textAlign:'right'}}>审核意见：</Col>
                        <Col span={20}>{initFormData.SHYJ}</Col>
                    </Row>
                </div>}
                <Viewer
                        visible={this.state.previewVisible}
                        onClose={this.handleCancel}
                        images={[{ src:this.state.previewImage, alt: '' }]}
                    />
            </div>
        );
    }
}

export default ViewForm;


// WEBPACK FOOTER //
// ./components/swbl/whrjLstd/ViewForm.js